
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import GradientPoint from "./GradientPoint.vue";

import {
  generateGradientStyle,
  updateGradientActivePercent,
  delayedBoundsCall
} from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/helpers";
import { GradientPoint as GradientPoint_ } from "@/types/colors";

@Component({
  components: {
    GradientPoint
  }
})
export default class GradientPoints extends Vue {
  @Prop()
  points!: GradientPoint_[];

  @Prop()
  activePointIndex!: number;

  @Prop()
  changeActivePointIndex!: Function;

  @Prop()
  updateGradientLeft!: Function;

  @Prop()
  addPoint!: Function;

  @Prop()
  removePoint!: Function;

  width = 0;
  positions = { x: 0, y: 0 };
  dragging = false;

  get pointsStyle() {
    const style = generateGradientStyle(this.points, "linear", 90);
    return { background: style };
  }

  mounted() {
    delayedBoundsCall(this.calculateBounds);
  }

  calculateBounds() {
    const pointer = this.$refs.pointsContainerRef as HTMLElement;

    if (pointer) {
      const pointerPos = pointer.getBoundingClientRect();
      this.width = pointer.clientWidth;
      this.positions = { x: pointerPos.x, y: pointerPos.y };
    }
  }

  maybeAddPoint(event: MouseEvent) {
    if (this.dragging) return;

    this.calculateBounds();

    const left = updateGradientActivePercent(
      event.pageX - this.positions.x,
      this.width
    );

    this.addPoint(left);
  }
}
